var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 18,
    fill: "#FFF6F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3663_50549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2473 24.1605L42.1552 27.3071C43.1641 29.3195 43.6581 31.5506 43.5928 33.8008C43.5275 36.0509 42.905 38.2497 41.781 40.2001H18.2063C16.7455 37.6659 16.1402 34.7284 16.4802 31.8232C16.8201 28.9179 18.0871 26.1996 20.0935 24.071C22.0998 21.9425 24.7386 20.5172 27.6188 20.0063C30.4989 19.4954 33.4669 19.9263 36.0829 21.2349L39.2296 19.1428C36.0259 17.0884 32.2258 16.1679 28.4371 16.5284C24.6485 16.8888 21.0901 18.5095 18.3313 21.1312C15.5725 23.7528 13.7727 27.2239 13.2196 30.9893C12.6666 34.7547 13.3923 38.5968 15.2808 41.901C15.5776 42.4151 16.0038 42.8426 16.5171 43.141C17.0303 43.4394 17.6127 43.5983 18.2063 43.6019H41.764C42.3634 43.6043 42.9528 43.4482 43.4726 43.1495C43.9923 42.8508 44.4239 42.4201 44.7236 41.901C46.2908 39.1862 47.0773 36.0911 46.9962 32.9575C46.9152 29.8239 45.9697 26.7736 44.2643 24.1434L44.2473 24.1605ZM27.5954 35.7947C27.9111 36.1114 28.2862 36.3627 28.6992 36.5341C29.1122 36.7056 29.555 36.7938 30.0022 36.7938C30.4494 36.7938 30.8921 36.7056 31.3051 36.5341C31.7182 36.3627 32.0933 36.1114 32.409 35.7947L42.0361 21.354L27.5954 30.9811C27.2791 31.2971 27.0282 31.6722 26.857 32.0852C26.6858 32.4982 26.5977 32.9409 26.5977 33.3879C26.5977 33.835 26.6858 34.2776 26.857 34.6906C27.0282 35.1036 27.2791 35.4788 27.5954 35.7947Z",
    fill: "#E34A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3663_50549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.8a2784bbd2a9522cdaf4d60e7e84c604.svg";
export { ForwardRef as ReactComponent };